// extracted by mini-css-extract-plugin
module.exports = {"nonIdealState":"NonIdealState_nonIdealState__1KTDq","header":"NonIdealState_header__3jdc7","attentionGrabber":"NonIdealState_attentionGrabber__2ZLwB"};